/**
 * definizione protocollo tra json che arriva dal server e le strutture
 * dati interne alla libreria javascript
 * In caso di server con formato di dati diverso aggiungere un protocollo e definire
 * le trasformazioni in caso di record o di lista
 *
 */

var Protocol = Class.extend({
    value : null,
    metadata : {},
    resultParams : {},
    validationRules : {},
    backParams : {},
    summary : {},
    jsonToData : function (json) {
        throw "override jsonToData function ";
    }
})

var RecordProtocol = Protocol.extend({
    jsonToData : function (json) {
        this.value = json.result;
        this.metadata = json.metadata;
        this.resultParams = json.resultParams;
        this.validationRules = json.validationRules;
        this.backParams = json.backParams;
    }
});

var ListProtocol = Protocol.extend({
    pagination :{},
    has_errors : false,
    jsonToData : function (json) {
        this.value = json.result.data;
        this.metadata = json.metadata;
        this.pagination = _.omit(json.result, ['data','has_errors']);
        this.resultParams = json.resultParams;
        this.summary = json.summary;
        this.validationRules = json.validationRules;
        this.backParams = json.backParams;
        this.has_errors = (json.result.has_errors == true);
        this.list_header = json.data_header;
    }
});
